document.addEventListener("DOMContentLoaded", function () {
    if (!Foundation.MediaQuery.atLeast('xlarge')) {
        var searchButton = document.querySelector(".header-container .search");
        var logo = document.querySelector(".header-container .logo");
        var searchForm = document.getElementById("search-pane");

        // Function to update logo visibility
        function updateLogoVisibility() {
            var isExpanded = searchButton.getAttribute("aria-expanded") === "true";
            logo.style.display = isExpanded ? "none" : "block";
        }

        // Initial state setup
        updateLogoVisibility();

        searchButton.addEventListener("click", function (event) {
            event.stopPropagation();
            var isExpanded = searchButton.getAttribute("aria-expanded") === "true";
            searchButton.setAttribute("aria-expanded", !isExpanded);
            searchForm.classList.toggle("is-open");
            searchForm.setAttribute("aria-hidden", isExpanded);
            updateLogoVisibility();
        });

        // Hide search pane and show logo when clicking outside of the search pane
        document.addEventListener("click", function (event) {
            if (!event.target.closest("#search-pane") && searchButton.getAttribute("aria-expanded") === "true") {
                searchForm.classList.remove("is-open");
                searchForm.setAttribute("aria-hidden", "true");
                searchButton.setAttribute("aria-expanded", "false");
                updateLogoVisibility();
            }
        });

        // Prevent event from bubbling up when clicking inside the search pane
        searchForm.addEventListener("click", function (event) {
            event.stopPropagation();
        });
    }
});
